import { useHandler } from "@redotech/react-util/hook";
import {
  StringMatchOperator,
  textMatchOperators,
} from "@redotech/redo-model/advanced-flow/expressions/text-expression";
import {
  OmsOrderNotesConditionStep,
  OmsStreetAddressConditionStep,
  stringMatchOperatorToLabel,
} from "@redotech/redo-model/advanced-flow/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-model/advanced-flow/steps";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { DeepPartial } from "..";

const stringMatchOperatorOptions: RedoListItem<StringMatchOperator>[] =
  textMatchOperators.map((type) => ({
    value: type,
    type: "text",
    id: type,
    text: stringMatchOperatorToLabel[type],
  }));

export const StringMatchTypeSelect = memo(function StringMatchTypeSelect({
  step,
  setStep,
}: {
  step:
    | DeepPartial<OmsStreetAddressConditionStep>
    | DeepPartial<OmsOrderNotesConditionStep>;
  setStep: (step: DeepPartial<OmsConditionStep>) => void;
}) {
  const setMatchType = useHandler(
    ({
      item: matchTypeListItem,
    }: {
      item: RedoListItem<StringMatchOperator>;
    }) => {
      setStep({ ...step, matchType: matchTypeListItem.value });
    },
  );
  return (
    <Flex align="center" dir="row" gap="md" wrap="wrap">
      <RedoSingleSelectDropdownInput<StringMatchOperator>
        fitToAnchor={false}
        flexGrow={false}
        options={stringMatchOperatorOptions}
        optionSelected={setMatchType}
        placeholder="Select a criteria"
        selectedItem={stringMatchOperatorOptions.find(
          (o) => o.id === step.matchType,
        )}
        size="xs"
      />
    </Flex>
  );
});
